import { create } from "zustand";

/**
 * The in-app creation viewer (founder, 08-03: clicking an md creation opened
 * a tab of raw source). One global target; the modal mounts once in AppShell
 * so every surface (turn cards, story shelf, files grid) shares it without
 * per-surface wiring — openCreation routes viewable kinds here.
 */
export interface CreationViewerTarget {
  /** public_id — `/v/${id}` is the fetchable, owner-gated content URL. */
  id: string;
  /** Filename with extension; drives the viewer's renderer dispatch. */
  filename: string;
}

interface CreationViewerState {
  target: CreationViewerTarget | null;
  open: (target: CreationViewerTarget) => void;
  close: () => void;
}

export const useCreationViewerStore = create<CreationViewerState>((set) => ({
  target: null,
  open: (target) => set({ target }),
  close: () => set({ target: null }),
}));

/** Imperative open for non-React call sites (openCreation in shareLink). */
export function openCreationViewer(target: CreationViewerTarget): void {
  useCreationViewerStore.getState().open(target);
}
